import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CourseManagmentService } from 'src/app/services/course-managment.service';
import { AddCourseTimingComponent } from './add-course-timing/add-course-timing.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-add-course',
  templateUrl: './add-course.component.html',
  styleUrl: './add-course.component.scss'
})
export class AddCourseComponent implements OnInit, OnDestroy {
  courseTypeImg!: string;
  courseForm: FormGroup;
  subscription: Subscription | undefined;
  loading: boolean = false;
  constructor(
    private fb: FormBuilder, public dialogRef: MatDialogRef<AddCourseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private courseManagmentService: CourseManagmentService,
    public dialog: MatDialog,
  ) {
    this.courseForm = this.fb.group({
      courseType: [{value: this.data?.clubsList?.length ? this.data.clubsList[0].id : '', disabled: !!this.data.courseId,},
       Validators.required],
      location: ['', Validators.required],
      availablePlaces: [null, [Validators.required, Validators.min(0)]],
      instructor: ['', Validators.required],
    });
  }
  ngOnInit(): void {
    this.loading = true;
    if (this.data.courseId) {
      this.getCourseDetails();
    } else this.patchForm();
    this.subscription = this.courseForm.get('courseType')?.valueChanges.subscribe((selectedId) => {
      this.loadCourseImage(selectedId);
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  public castFormControl(controlName: string): FormControl {
    return this.courseForm.get(controlName) as FormControl;
  }

  hasError(controlName: string, errorType: string): boolean {
    const control = this.courseForm.get(controlName);
    return control ? control.hasError(errorType) && control.touched : false;
  }

  public onInputChange(value: string, controlName: string): void {
    const control = this.courseForm.get(controlName);
    if (control) {
      control.setValue(value);
      control.markAsDirty();
      control.updateValueAndValidity();
    }
  }

  loadCourseImage(selectedId: string): void {
    this.courseTypeImg=''
    const selectedCourse = this.data.clubsList.find((course: any) => course.id === selectedId);
    if (selectedCourse) {
      this.courseManagmentService.getCourseCreationImageByPath(selectedCourse.path)
        .subscribe({
          next: (blob) => {
            this.courseTypeImg = URL.createObjectURL(blob);
          },
          error: () => {
            this.courseTypeImg = '';
          },
        });
    }
  }

  getCourseDetails(){
      this.courseManagmentService.getCourseById(this.data.courseId).subscribe(
        (result: any) => {
          const updatedCourseData = {
            courseType: result.clubId,
            location: result.location,
            availablePlaces: result.placeNumber,
            instructor: result.coachName,
            courseDates: result.courseDate,
            startTime: result.startTimeCourse,
            endTime: result.endTimeCourse,
          };
          this.courseManagmentService.updateCourseData(updatedCourseData);
          this.patchForm();          
        },
        (error) => {
          console.error("Erreur lors de la récupération des données :", error);
        }
      );

  }
  
  patchForm() {
      const courseData = this.courseManagmentService.getCourseData()
      if (courseData) {
        this.courseForm.patchValue({
          courseType: courseData?.courseType !== '' ? courseData?.courseType : this.data.clubsList[0].id,
          location: courseData?.location,
          availablePlaces: courseData?.availablePlaces,
          instructor: courseData?.instructor,
        });
      }
    this.loading=false;
    this.loadCourseImage(this.courseForm.get('courseType')?.value);
  }

  continue() {
    const updatedCourseData = {
      courseType: this.courseForm.getRawValue().courseType,
      location: this.courseForm.value.location,
      availablePlaces: this.courseForm.value.availablePlaces,
      instructor: this.courseForm.value.instructor
    };
    const currentCourseData = this.courseManagmentService.getCourseData();
    const mergedCourseData = {
      ...currentCourseData,
      ...updatedCourseData
    };
    this.courseManagmentService.updateCourseData(mergedCourseData);
    this.dialogRef.close()
    const dialogData = this.data.courseId ? 
    { clubsList: this.data.clubsList, courseId: this.data.courseId } : { clubsList: this.data.clubsList };
  
    const dialogRef = this.dialog.open(AddCourseTimingComponent, { data: dialogData });
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}